<template>
    <v-container class="pa-5" fluid>
        <ChangePriorityDialog
            :is-open="changePriorityDialog"
            :scheduled-tasks="priorityDialogTasks"
            :loading="actionLoading.priorityDialogTasks"
            :saving="actionLoading.changePriority"
            @on-save="saveChangePriority"
            @on-close="closeChangePriorityDialog"
        />

        <page-title>Priorytetyzacja na stanowiskach produkcyjnych</page-title>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="productionSites"
                        :loading="productionSitesLoading"
                        hide-default-footer
                        disable-pagination
                        :mobile-breakpoint="0"
                        no-data-text="Brak stanowisk."
                        loading-text="Pobieranie stanowisk..."
                    >
                        <template #item.type="{item}">
                            {{ parseEmptyValue(item.type.name) }}
                        </template>

                        <template #item.actions="{item}">
                            <div class="text-right">
                                <v-btn
                                    color="secondary"
                                    small
                                    depressed
                                    @click="changePriority(item)"
                                >
                                    Zmień priorytet
                                </v-btn>
                            </div>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import PageTitle from '@/components/common/PageTitle'
import ChangePriorityDialog from './ChangePriorityDialog'
import parse from '@/mixins/parse'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'ReportsPrioritization',
    components: {
        PageTitle,
        ChangePriorityDialog
    },
    mixins: [ parse ],
    data() {
        return {
            changePriorityDialog: false,
            priorityDialogTasks: [],
            selectedProductionSite: null,
            actionLoading: {
                priorityDialogTasks: false,
                changePriority: false
            },
            headers: [
                {
                    text: 'Nazwa stanowiska',
                    value: 'name',
                    sortable: false
                },
                {
                    text: 'Typ stanowiska',
                    value: 'type',
                    sortable: false
                },
                {
                    text: 'Akcje',
                    value: 'actions',
                    sortable: false,
                    align: 'center',
                    width: 180
                }
            ]
        }
    },
    computed: {
        productionSites() {
            const sites = this.$store.state.reports.prioritization.productionSites

            return [...sites].sort((a, b) => (a.name || '').localeCompare(b.name || '', 'pl'))
        },
        productionSitesLoading() {
            return this.$store.state.reports.prioritization.productionSitesLoading
        }
    },
    mounted() {
        this.getProductionSites()
    },
    methods: {
        getProductionSites() {
            this.$store.dispatch('reports/prioritization/getPlanPrioritizationProductionSites')
                .catch(() => {})
        },
        changePriority(item) {
            this.selectedProductionSite = item
            this.changePriorityDialog = true
            this.actionLoading.priorityDialogTasks = true
            this.priorityDialogTasks = []

            this.$store.dispatch('reports/prioritization/getScheduledTasks', {
                productionSiteId: item.id,
                machineCode: item.machine?.code,
                sortByPriority: false
            })
                .then(response => {
                    this.priorityDialogTasks = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.priorityDialogTasks = false
                })
        },
        closeChangePriorityDialog() {
            this.changePriorityDialog = false
            this.selectedProductionSite = null
        },
        saveChangePriority(changedTasks) {
            if (changedTasks.length === 0) {
                this.closeChangePriorityDialog()

                return
            }

            this.actionLoading.changePriority = true

            const payload = {
                productionSiteId: this.selectedProductionSite.id,
                tasks: changedTasks.map(task => ({
                    procTaskId: task.procTaskId,
                    priority: task.priority
                }))
            }

            this.$store.dispatch('reports/prioritization/updateTasksPriority', payload)
                .then(() => {
                    this.$store.dispatch('showNotification', {
                        type: 'success',
                        message: 'Priorytety zostały zapisane.'
                    })
                    this.closeChangePriorityDialog()
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.actionLoading.changePriority = false
                })
        }
    }
}
</script>
